// Marque Gestimmony — icône officielle (maison + clé + barres de croissance)
// Rendue depuis l'asset détouré /logo-mark.png (fond transparent, ratio ~1:2).

export const LogoMark = ({ className = "h-9", ...props }) => (
  <img
    src="/logo-mark.png"
    alt="Gestimmony"
    draggable={false}
    data-testid="logo-mark"
    className={`${className} w-auto object-contain select-none`}
    {...props}
  />
);

export const Logo = ({ markClassName = "h-9", textClassName = "font-heading font-bold text-lg tracking-tight", label = "Gestimmony" }) => (
  <span className="flex items-center gap-2">
    <LogoMark className={markClassName} />
    <span className={textClassName}>{label}</span>
  </span>
);
